/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useState } from 'react';
import PropTypes from 'prop-types';
import { SpinnerProps } from './SpinnerProps';
import { SpinnerPositionTypes } from './SpinnerPositionTypes';
import spinner from '../../../assets/images/gif/1080p/spinner.gif';

import './Spinner.scss';

const Spinner: FunctionComponent<SpinnerProps> = (props): JSX.Element => {
    const {
        message,
        position = SpinnerPositionTypes.DEFAULT,
        channelNumber,
        errorCodes,
        background,
    } = props;

    const [isSpinnerLoaded, setIsSpinnerLoaded] = useState(false);

    const spinnerClass = `spinner-container ${position} ${errorCodes ? 'with-error-codes' : ''} ${
        background ? 'with-background' : ''
    }`;

    return (
        <div className={spinnerClass} data-testid="spinner-container">
            <div className="message" data-test-id="spinner-message">
                {message}
            </div>
            <div className={isSpinnerLoaded ? 'spinner-loaded' : 'spinner'}>
                <img
                    src={spinner}
                    style={isSpinnerLoaded ? { height: '18.52vh' } : { display: 'none' }}
                    onLoad={() => setIsSpinnerLoaded(true)}
                />
            </div>
            {errorCodes ? (
                <div className="channel-number">
                    {channelNumber} <span className="error-codes">{errorCodes}</span>
                </div>
            ) : null}
        </div>
    );
};

Spinner.propTypes = {
    message: PropTypes.string.isRequired,
    position: PropTypes.string,
    channelNumber: PropTypes.string,
    errorCodes: PropTypes.string,
    background: PropTypes.bool,
};

export default Spinner;
